import Vue from "vue";

import get from "lodash/get";
import startCase from "lodash/startCase";

const formatDate = (date) => {
  if (isNaN(Date.parse(date))) {
    return date;
  }

  const dateObject = new Date(date);

  try {
    return String(dateObject.toLocaleDateString() + " " + dateObject.toLocaleTimeString()).trim();
  } catch (e) {
    return date;
  }
};

export default Vue.mixin({
  methods: {
    formatDate,
    showResponseError({ response }) {
      window.Notify.warning(
        get(response, "data.message", get(response, "message", "Something went wrong")),
      );
    },
    pairTableLabelWithValue(object) {
      return Object.keys(object).map((key) => {
        return { text: key, value: object[key] };
      });
    },
    titleCase(value) {
      return startCase(value);
    },
    extractDataKey(...args) {
      return get(...args);
    },

    objectValueFromPath(...args) {
      return get(...args);
    },
    asCurrency(value) {
      return +value ? Number(value).toLocaleString() : value;
    },
  },

  filters: {
    date(value) {
      return formatDate(value);
    },
    title(value) {
      return startCase(value);
    },
    currency(value) {
      return +value ? Number(value).toLocaleString("de-DE") : value;
    },
    crypto(value) {
      return +value
        ? Number(value).toLocaleString("de-DE", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 5,
          })
        : value;
    },
  },
});
